import Keycloak from "keycloak-js";
import { getInitOptions } from "pages/keycloakpage/options";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTenant } from "redux/reducers/global/actions";

import { TenantType } from "types/generic/tenant";
import {
    REACT_APP_KEYCLOAK_CLIENT_ID,
    REACT_APP_KEYCLOAK_REALM,
    REACT_APP_KEYCLOAK_URL,
    getEnvVariable,
    getTenant,
} from "utils/environment";

type AppConfigType = {
    tenant: TenantType | null;
};

type keyCloakSettingsType = {
    authClient: Keycloak.KeycloakInstance;
    initOptions: {
        onLoad: string;
        checkLoginIframe: boolean;
    };
};
export const useAppConfig = () => {
    const dispatch = useDispatch();
    const logged = useSelector<any>((state) => state?.keycloak?.logged);

    const setCurrentTenant = ({ tenant }: AppConfigType) => {
        if (!tenant) return;

        if (!logged) {
            return;
        }

        dispatch(updateTenant(tenant));
    };

    const getKeycloakSettings = useCallback(
        async (
            setStoredTenant: React.Dispatch<
                React.SetStateAction<TenantType | null>
            >,
            setKeyCloakSettings: React.Dispatch<
                React.SetStateAction<keyCloakSettingsType | null>
            >,
            currentWindow: Window
        ) => {
            if (!currentWindow.location.pathname.includes("access")) {
                try {
                    const tenant = await getTenant();
                    setStoredTenant(tenant);
                    const initOptions = getInitOptions(tenant);
                    const keycloakInstance = Keycloak(initOptions);
                    const keyCloakSettings = {
                        authClient: keycloakInstance,
                        initOptions: {
                            ...initOptions,
                            onLoad: "login-required",
                            checkLoginIframe: false,
                        },
                    };
                    setKeyCloakSettings(keyCloakSettings);
                } catch (error) {
                    currentWindow.location.replace("/access");
                    console.error(error);
                }
            } else {
                const tenant = {
                    tenantName: "",
                    realm: getEnvVariable(REACT_APP_KEYCLOAK_REALM),
                    originUrl: "",
                    destinationUrl: "",
                    clientId: getEnvVariable(REACT_APP_KEYCLOAK_CLIENT_ID),
                    authUrl: getEnvVariable(REACT_APP_KEYCLOAK_URL),
                    portalUrl: "",
                };
                setStoredTenant(tenant);
                const initOptions = getInitOptions(tenant);
                const keycloakInstance = Keycloak(initOptions);
                const keyCloakSettings = {
                    authClient: keycloakInstance,
                    initOptions: {
                        ...initOptions,
                        onLoad: "login-required",
                        checkLoginIframe: false,
                    },
                };
                setKeyCloakSettings(keyCloakSettings);
            }
        },
        []
    );

    return { setCurrentTenant, getKeycloakSettings };
};
